import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'gen-filters-sections',
  templateUrl: './filters-sections.component.html',
  styleUrls: ['filters-sections.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class FiltersSectionsComponent {

  @Input() filtersSections;

  originalOrder() {
    return 0;
  }

}
